import * as React from 'react';
import * as classNames from "classnames";
import { PageConfig } from "./configuration/IConfiguration";
import InternalClassificationNavLink from './Common/Links/InternalClassificationNavLink';
import InternalAbsoluteLink from './Common/Links/InternalAbsoluteLink';
import * as DTOS from "../../FeralScan.dtos";

const MenuItemList = (items: PageConfig[], currentUser: DTOS.User, itemClassName?: string) => (
    items
        .filter(item => item.generateNav
            && (!item.generateNavIfLoggedIn || currentUser)
            && (!item.generateNavIfHasRole || (currentUser && currentUser.userRoles && currentUser.userRoles.find(r => r === item.generateNavIfHasRole)))
        )
        .map((item, i) => {
            switch (item.type) {
                case "PAGE":
                    return InternalClassificationNavLink(item.route[0], item.name, item.icon, itemClassName)
                case "LINK":
                    return item.link ? <a
                        className={itemClassName}
                        key={`navlink-${item.name}`}
                        href={item.link}
                        target="_blank"
                    >
                        {item.icon ? <i className={classNames("fa", item.icon)} aria-hidden="true"></i> : null}
                        {item.name}
                    </a >
                        : InternalAbsoluteLink(item.route, item.name, item.icon, itemClassName)
            }
        })
);

export default MenuItemList;